/* unplugin-vue-components disabled */import { render } from "./ai-text.vue?vue&type=template&id=b9cd7a68&scoped=true"
import script from "./ai-text.vue?vue&type=script&lang=js"
export * from "./ai-text.vue?vue&type=script&lang=js"

import "./ai-text.vue?vue&type=style&index=0&id=b9cd7a68&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9cd7a68"],['__file',"src/components/ai-chat/ai-assistant/ai-input/ai-text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9cd7a68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9cd7a68', __exports__)) {
    api.reload('b9cd7a68', __exports__)
  }
  
  module.hot.accept("./ai-text.vue?vue&type=template&id=b9cd7a68&scoped=true", () => {
    api.rerender('b9cd7a68', render)
  })

}


export default __exports__